import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import FaqTicketCreate from '../common/FaqTicketCreate';
import PaymentChequeDisclaimer from './PaymentChequeDisclaimer';
import { clickTracker } from '../../lib/common';

const ChequeStatusFaq = ({
  data,
  showTicketCreate,
  setShowTicketCreate,
  faqObj,
  activeIndex,
  setShowData,
  stopChequeFaqObj,
}) => {
  const handlePaymentsCheckButton = async () => {
    if (data?.hasRedirection) {
      await clickTracker('FAQ_contractinactive_updatekyc', 'payments_FAQ_contractinactive');
      window.location = data?.url;
    } else {
      setShowTicketCreate(true);
    }
  };

  return (
    <div className="p-10">
      {showTicketCreate ? (
        <FaqTicketCreate
          issue={faqObj?.issue || ''}
          subIssue={faqObj?.subIssue || ''}
          activeIndex={activeIndex}
          vertical="Listing"
          category="CS"
          ticketCreator="BUSINESS"
          setShowData={setShowData}
          hideAlert
          hideCrossIcon={false}
          id="paymentChequeStatus"
          faqId={faqObj?.pop}
          setShowTicketCreate={setShowTicketCreate}
          faqObj={faqObj}
        />
      ) : (
        <>
          {faqObj.pop === 7 ? (
            <>
              {data?.text && <div className="font12 fw500">{data?.text || ''}</div>}
              <div className="font12 fw400 mt-10">{data?.subText || ''}</div>
              {data?.buttonText && (
                <div className="mt-10">
                  <button
                    onClick={() => handlePaymentsCheckButton()}
                    type="button"
                    className={`${styles.submit__Btn} font13 fw500 colorFFF`}
                  >
                    {data?.buttonText}
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              {stopChequeFaqObj?.chequeCleared ? (
                <div className="font12 fw500">{stopChequeFaqObj?.text || ''}</div>
              ) : (
                <PaymentChequeDisclaimer setShowTicketCreate={setShowTicketCreate} />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ChequeStatusFaq;

ChequeStatusFaq.propTypes = {
  data: PropTypes.object,
  showTicketCreate: PropTypes.bool,
  setShowTicketCreate: PropTypes.func,
  faqObj: PropTypes.object,
  activeIndex: PropTypes.number,
  setShowData: PropTypes.func,
  stopChequeFaqObj: PropTypes.object,
};
